<app-banner [heading]="'CAREER - JOIN US'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class=""> <h3>
			<a href="https://drive.google.com/file/d/1Lj3p5n_D0vawTWHZCVAfiRDE2PGGCksr/view?usp=sharing" target="_blank"> Download Recruitment form </a> 
				</h3>
            </div>
          </div>

          
		</div>
      </div>
	</section><!-- End About Section -->
	
	

	
	
    
    
  </main>